import React, { useState } from 'react';
import styled from 'styled-components';

import PropTypes from 'prop-types';

import Button from 'components/Button';
import { ButtonGroup } from 'apps/components/shared';

import SubtemplateList from './subtemplateList';

const SelectSubtemplateContent = props => {
  const {
    subsections,
    userJourneysData,
    clickConfirm,
    clickCancel,
    filledSections,
  } = props;

  // List of user journey names
  const journeyKeys = Object.keys(userJourneysData);

  const userJourneyItems = [];

  let uniqueSet = new Set();

  if (filledSections) {
    filledSections.forEach(subtemplateId => {
      uniqueSet.add(subtemplateId);
    });
  }

  // For each user journey, create an item that will hold its current status
  for (let i = 0; i < journeyKeys.length; i += 1) {
    const journey = userJourneysData[journeyKeys[i]];

    userJourneyItems.push({
      text: journey.title,
      key: journeyKeys[i],
      requiredBlocks: journey.requiredBlocks, // Required substeps of the template
      selected: false,
    });
  }

  const subtemplateInitialStatus = {};
  Object.keys(subsections).forEach(key => {
    subtemplateInitialStatus[key] = {
      isSelected: !!uniqueSet.has(key),
      description: subsections[key].description,
      title: subsections[key].title,
      file: subsections[key].file,
    };
  });

  const [userJourneysItems, SetUserJourneysItems] = useState(userJourneyItems);
  const [selectedSubsections, SetSelectedSubsections] = useState(
    subtemplateInitialStatus,
  );

  const updateSelectedSubsections = (subtemplateKey, value) => {
    const newCbState = Object.assign({}, selectedSubsections);
    newCbState[subtemplateKey].isSelected = value;
    SetSelectedSubsections(newCbState);
  };

  const onUserJourneySelected = userJourneyKey => {
    const newCbState = Object.assign({}, selectedSubsections);
    const newButtonState = Object.assign([], userJourneysItems);

    // Clean the set
    uniqueSet = new Set();

    // Iterate through all the user journeys, and change the status
    // of the current one
    for (let i = 0; i < newButtonState.length; i += 1) {
      if (newButtonState[i].key === userJourneyKey) {
        newButtonState[i].selected = !newButtonState[i].selected;
      }

      if (newButtonState[i].selected === true) {
        // eslint-disable-next-line no-loop-func
        newButtonState[i].requiredBlocks.forEach(bl => {
          uniqueSet.add(bl);
        });
      }
    }

    // Iterate through the keys, and set to true those in the set
    Object.keys(subsections).forEach(key => {
      newCbState[key].isSelected = !!uniqueSet.has(key);
    });

    SetSelectedSubsections(newCbState);
    SetUserJourneysItems(newButtonState);
  };

  const listItems = userJourneysItems.map(uji => {
    let buttonStyle = {};
    if (uji.selected) {
      buttonStyle = {
        color: '#0f2eff',
        borderColor: '#0f2eff',
      };
    }

    return (
      <>
        <UserJourneyPill
          key={`bt_${uji.key}`}
          style={buttonStyle}
          onClick={() => {
            onUserJourneySelected(uji.key);
          }}
        >
          {uji.text}
        </UserJourneyPill>
      </>
    );
  });

  return (
    <>
      <SubsectionsHeader>
        <h4>What steps are you planning to manage in the project?</h4>
        <p>
          Click on all of them and we will suggest you the relevant
          documentation
        </p>

        <div>{listItems}</div>
      </SubsectionsHeader>

      <SubtemplateList
        selectedSubsections={selectedSubsections}
        updateSelectedSubsections={updateSelectedSubsections}
      ></SubtemplateList>

      <ButtonGroup spacing='default' alignment='center'>
        <Button
          outline
          text='Cancel'
          onClick={() => {
            if (clickCancel) clickCancel();
          }}
        />
        <Button
          icon='arrow_right'
          iconPosition='right'
          text='Confirm'
          onClick={() => {
            if (clickConfirm) {
              clickConfirm(selectedSubsections, filledSections);
            } else {
              console.error('Confirm not set');
            }
          }}
        />
      </ButtonGroup>
    </>
  );
};

export default SelectSubtemplateContent;

SelectSubtemplateContent.propTypes = {
  subsections: PropTypes.object,
  userJourneysData: PropTypes.object,
  clickConfirm: PropTypes.func,
  clickCancel: PropTypes.func,
  filledSections: PropTypes.array,
};

const UserJourneyPill = styled.div`
  border: solid;
  border-width: 1.5px;

  font-family: HelveticaNowDisplay;
  font-size: 14px;
  color: black;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 16px;
  &:hover {
    color: #0f2eff;
  }
`;

const SubsectionsHeader = styled.div`
  margin: 0.25rem auto;
  margin-bottom: 20px;
  margin-top: 20px;

  padding: 0px 75px;

  h4,
  p {
    margin-bottom: 5px;
    text-align: left;
    font-family: HelveticaNowDisplay;
  }
  h4 {
    font-size: 18px;
  }
  p {
    font-size: 16px;
    margin-bottom: 15px;
  }
`;
